module.exports = __webpack_public_path__ + "img/2.261055d8.png";